import React from 'react';
import { PropTypes } from 'prop-types';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedHTMLMessage } from 'react-intl';
import Button from 'components/Common/Buttons';
import { history } from 'containers/App';
import { resetQuestionnaire } from 'actions/questionnaires';

const Home = ({ usePreQualifyingQuestionnaire, dispatch }) => {
  const startNewPQQuestionnaire = () => {
    dispatch(resetQuestionnaire());
    history.push('/pre-qualifying-questionnaire');
  };

  return (
    usePreQualifyingQuestionnaire ? <section>
      <div className="pre-questionnaire-landing col-12 col-lg-10 col-xl-8">
        <div className="welcome-card">
          <h1><FormattedHTMLMessage id="preQualifyingQuestionnaire.welcome" /></h1>
          <div className="welcome-text">
            <h3><FormattedHTMLMessage id="preQualifyingQuestionnaire.content" /></h3>
          </div>
          <Button className="btn-primary" value="Start" onClick={ startNewPQQuestionnaire } />
          <h4 className="mt-4"><FormattedHTMLMessage id="preQualifyingQuestionnaire.manualFormSelectText" /></h4>
          <Link to="/form-selection" className="btn btn-link"><FormattedHTMLMessage id="preQualifyingQuestionnaire.manualFormSelectLinkText" /></Link>
        </div>
      </div>
    </section> : <Redirect to="form-selection" />
  );
};

Home.propTypes = {
  usePreQualifyingQuestionnaire: PropTypes.bool,
  dispatch: PropTypes.func.isRequired
};

Home.defaultProps = {
  usePreQualifyingQuestionnaire: false
};

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    app: { onlineConfig }
  } = state;

  return {
    usePreQualifyingQuestionnaire: onlineConfig && onlineConfig.usePreQualifyingQuestionnaire
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
